/* Nuuke — le panier, c'est le tiroir AMP Slide Cart, partout (21/09/2026, décision Samuel).
   1. #cart dans l'URL (arrivée depuis /cart, voir snippets/tw-amp-cart.liquid) → on ouvre le tiroir AMP.
   2. Bloc « Go to 6 tanks » (snippets/tw-cart-boost) posé DANS le tiroir AMP : rendu côté serveur par
      sections/tw-cart-boost-amp.liquid via l'API Section Rendering, rechargé à chaque ouverture / mise à jour.
      AMP redessine son tiroir (Preact) : un observateur repose le bloc s'il disparaît.
   3. Compteur du panier dans l'en-tête Horizon : mis à jour depuis le panier d'AMP (le thème n'entend plus ses
      propres événements quand l'ajout passe par AMP).
   Hooks AMP : window.SLIDECART_LOADED / _OPENED / _UPDATED / _CLOSED sont de simples fonctions globales appelées
   par l'app — on les chaîne sans écraser celles qui existeraient déjà. */
(function () {
  if (window.__twAmpCart) return;
  window.__twAmpCart = true;

  var racine = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var SECTION = 'tw-cart-boost-amp';

  function amp() { return typeof window.SLIDECART_OPEN === 'function' && typeof window.SLIDECART_UPDATE === 'function'; }

  function chainer(nom, fn) {
    var avant = window[nom];
    window[nom] = function () {
      try { if (typeof avant === 'function') avant.apply(this, arguments); } catch (e) {}
      try { fn.apply(this, arguments); } catch (e) { if (window.console) console.warn('[tw-amp-cart]', nom, e); }
    };
  }

  /* ---------- 1. Ouverture sur #cart ---------- */
  function ouvrirSiDemande() {
    if (location.hash !== '#cart') return;
    var debut = Date.now();
    (function tick() {
      if (amp()) {
        try { history.replaceState(null, '', location.pathname + location.search); } catch (e) {}
        window.SLIDECART_OPEN();
        return;
      }
      if (Date.now() - debut < 8000) setTimeout(tick, 80);
    })();
  }

  /* ---------- 2. Bloc « Go to 6 tanks » dans le tiroir ---------- */
  var html = null;        // dernier HTML rendu (vide = panier vide ou bloc masqué)
  var enCours = false;
  var minuteur = null;

  function tiroir() { return document.querySelector('#slidecarthq .slidecarthq'); }

  function poser() {
    var t = tiroir();
    if (!t) return;
    var boite = t.querySelector('.tw-amp-boost');
    if (!html) { if (boite) boite.parentNode.removeChild(boite); return; }
    if (!boite) {
      boite = document.createElement('div');
      boite.className = 'tw-amp-boost';
      boite.style.cssText = 'padding:12px 16px 0;';
      // Comme dans l'ancien tiroir Horizon : en tête, juste au-dessus des articles.
      var avant = t.querySelector('.items') || t.querySelector('.upsells') || t.querySelector('footer');
      if (avant) t.insertBefore(boite, avant); else t.appendChild(boite);
    }
    if (boite.getAttribute('data-tw-html') !== html) {
      boite.innerHTML = html;
      boite.setAttribute('data-tw-html', html);
    }
  }

  /* 24/09 : bloc « Go to 6 tanks » RETIRÉ du panier (US + FR), demande de Samuel. Remettre true pour le réactiver. */
  var BOOST_ACTIF = false;

  function rafraichir() {
    if (!BOOST_ACTIF) { html = ''; poser(); return; }
    if (enCours) { clearTimeout(minuteur); minuteur = setTimeout(rafraichir, 300); return; }
    enCours = true;
    fetch(racine + '?sections=' + SECTION, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : {}; })
      .then(function (j) {
        var brut = j && j[SECTION];
        if (typeof brut !== 'string') return;
        var doc = new DOMParser().parseFromString(brut, 'text/html');
        var sec = doc.body.firstElementChild;
        var contenu = sec ? sec.innerHTML.trim() : '';
        // Le snippet charge tw-cart.js en <script> : déjà présent sur la page, et un script injecté ne s'exécute pas.
        // Son <style> part une fois dans <head> : AMP affiche le texte des <style> posés dans son tiroir.
        contenu = contenu.replace(/<script[^>]*><\/script>/g, '').replace(/<style>([\s\S]*?)<\/style>/g, function (_, css) {
          if (!document.getElementById('tw-amp-boost-style')) {
            // Préfixe #slidecarthq : les règles d'AMP (.slidecarthq div, …) sont plus spécifiques que .twcb seul.
            var st = document.createElement('style'); st.id = 'tw-amp-boost-style'; st.textContent = css.replace(/\.twcb/g, '#slidecarthq .twcb'); document.head.appendChild(st);
          }
          return '';
        });
        html = /class="twcb"/.test(contenu) ? contenu : '';
        poser();
      })
      .catch(function (e) { if (window.console) console.warn('[tw-amp-cart]', e); })
      .then(function () { enCours = false; });
  }

  function observer() {
    var hote = document.getElementById('slidecarthq');
    if (!hote) { setTimeout(observer, 500); return; }
    var attente = null;
    new MutationObserver(function () {
      if (attente) return;
      attente = requestAnimationFrame(function () {
        attente = null;
        var t = tiroir();
        if (t && html && !t.querySelector('.tw-amp-boost')) poser();
      });
    }).observe(hote, { childList: true, subtree: true });
  }

  /* ---------- 3. Compteur de l'en-tête ---------- */
  function compteur(cart) {
    if (!cart || typeof cart.item_count !== 'number') return;
    var n = cart.item_count;
    document.querySelectorAll('.cart-bubble').forEach(function (b) {
      b.classList.toggle('visually-hidden', n === 0);
      var c = b.querySelector('.cart-bubble__text-count');
      if (c) { c.textContent = n < 100 ? String(n) : '99+'; c.classList.toggle('hidden', n === 0); }
    });
  }

  chainer('SLIDECART_LOADED', function (cart) { compteur(cart); rafraichir(); });
  chainer('SLIDECART_OPENED', function () { rafraichir(); });
  chainer('SLIDECART_UPDATED', function (cart) { compteur(cart); rafraichir(); });
  document.addEventListener('tw:cart-changed', rafraichir);

  /* ---------- 4. Tiroir AMP en français (24/09, visiteuses /fr-fr et /fr-ch) ----------
     Filet de sécurité : AMP a ses textes en anglais (« multilang » coupé dans l'app). On traduit ses libellés
     fixes quand la boutique est en français. Ne fait rien en anglais (US inchangé), et ne fait plus rien
     le jour où les traductions sont saisies dans AMP (les textes anglais n'apparaissent plus).
     Voir projets/2026-09-24-nuuke-fr/panier-fr/INSTRUCTIONS.md. */
  var locale = String((window.Shopify && Shopify.locale) || document.documentElement.lang || '').toLowerCase();
  if (locale.indexOf('fr') === 0) {
    var FR = {
      'Your Cart': 'Votre panier',
      'HIGH DEMAND': 'FORTE DEMANDE',
      'Your products are reserved for': 'Vos articles sont réservés pendant',
      'Add': 'Ajouter',
      'Adding...': 'Ajout…',
      'Apply': 'Appliquer',
      'Discount code': 'Code de réduction',
      'Invalid discount code': 'Code de réduction invalide',
      'Discounts': 'Réductions',
      'Subtotal': 'Sous-total',
      'Shipping': 'Livraison',
      'Calculated at checkout': 'Calculée au paiement',
      'SECURE CHECKOUT': 'PAIEMENT SÉCURISÉ',
      'Ship By Tomorrow': 'Expédié d’ici demain',
      'Your cart is empty': 'Votre panier est vide',
      'Shop now': 'Acheter maintenant',
      'Or continue shopping': 'Ou continuer mes achats',
      'View cart': 'Voir le panier',
      'Free': 'Offert',
      'Unavailable': 'Indisponible',
      'Show details': 'Voir le détail',
      'Hide details': 'Masquer le détail',
      'Color': 'Couleur',
      'Size': 'Taille',
      'Shade': 'Teinte'
    };
    var traduireTexte = function (v) {
      var t = v.trim();
      if (!t) return v;
      if (Object.prototype.hasOwnProperty.call(FR, t)) return v.replace(t, FR[t]);
      var m = t.match(/^\(Save (.+)\)$/);
      if (m) return v.replace(t, '(Économisez ' + m[1] + ')');
      return v;
    };
    var traduireAttr = function (el, nom) {
      var a = el.getAttribute(nom);
      if (!a) return;
      var b = a.replace(/^Your Cart\b/, 'Votre panier').replace(/^Add : /, 'Ajouter : ');
      if (nom === 'placeholder') b = traduireTexte(b);
      if (b !== a) el.setAttribute(nom, b);
    };
    var traduireTiroir = function () {
      var hote = document.getElementById('slidecarthq');
      if (!hote) return;
      var w = document.createTreeWalker(hote, NodeFilter.SHOW_TEXT), n;
      while ((n = w.nextNode())) {
        var p = n.parentElement;
        if (!p || p.closest('.tw-amp-boost, style, script')) continue;
        var nv = traduireTexte(n.nodeValue);
        if (nv !== n.nodeValue) n.nodeValue = nv;
      }
      hote.querySelectorAll('[aria-label], [placeholder]').forEach(function (el) {
        traduireAttr(el, 'aria-label'); traduireAttr(el, 'placeholder');
      });
    };
    (function observerFR() {
      var hote = document.getElementById('slidecarthq');
      if (!hote) { setTimeout(observerFR, 500); return; }
      var attente = null;
      traduireTiroir();
      new MutationObserver(function () {
        if (attente) return;
        attente = requestAnimationFrame(function () { attente = null; traduireTiroir(); });
      }).observe(hote, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['aria-label', 'placeholder'] });
    })();
  }

  /* ---------- 5. Loom Samuel 12/10 + Loom Matteo 11/10 (tiroir AMP, US) ----------
     a) Pack groupé : les lignes ajoutées ensemble par la buy box (propriété _bundle, ex. « 6 PACK — BUY 3, GET 3 FREE »)
        s'affichent en UNE carte « The Built-In Bra Tank — 6-Pack · Buy 3, Get 3 FREE » avec la liste couleur · taille.
        AFFICHAGE SEULEMENT : les lignes du panier, variantes, prix, réductions et total du checkout ne changent pas
        (les lignes AMP sont masquées en CSS, pas supprimées). La croix de la carte retire tout le pack (cart/update.js).
     b) Slider d'upsell : Boxer shapewear EN PREMIER, puis 3-in-1 Shaper Tank, puis FrostKnit (vrais produits, vraies
        photos de variante, vrai prix, couleur + taille à choisir, Add = la variante choisie). Les upsells AMP suivent.
     c) « Ship By Tomorrow » → « Ships Today » (mot de Matteo).
     d) Cadeau mystère : $29.00 barré puis $0.00 (FREE).
     Marché FR (/fr-fr, /fr-ch) : rien de tout ça (Nuuke = US pour l'instant ; le bloc 4 traduit le tiroir FR). */
  var LANG_FR = String((window.Shopify && Shopify.locale) || document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0;
  var DEVISE = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  if (!LANG_FR && !/^\/fr-(fr|ch)(\/|$)/.test(racine)) (function () {
    var UPSELLS = ['3-in-1-bamboo-boxer-shorts', 'the-3-in-1-shaper-tank', 'frostknit-invisible-shorts'];
    var CADEAUX = [45906528895085, 45906528927853, 45906528960621]; // 🎁 Free Mystery Gift (voir tw-gift.js)
    var CADEAU_VALEUR = 2900; // 29 $ barrés (Samuel 12/10)
    var panier = null, produits = null, attente = null, lecture = null;
    var barres = {}, barresLues = {}; // prix barré (compare_at) par variante, lu sur la fiche produit : comme AMP
    function lireBarres(handle) {
      if (!handle || barresLues[handle]) return;
      barresLues[handle] = true;
      fetch(racine + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { if (!p) return; p.variants.forEach(function (v) { barres[v.id] = v.compare_at_price || 0; }); planifier(); })
        .catch(function () {});
    }

    function argent(c) {
      try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: (panier && panier.currency) || DEVISE }).format(c / 100); }
      catch (e) { return '$' + (c / 100).toFixed(2); }
    }
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function img(u, w) { if (!u) return ''; u = String(u); if (u.indexOf('//') === 0) u = 'https:' + u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
    var CROIX = '<svg viewBox="0 0 20 20" width="16" height="16" aria-hidden="true"><path d="M5 5l10 10M15 5L5 15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';

    function style() {
      if (document.getElementById('tw-amp-loom-style')) return;
      var st = document.createElement('style'); st.id = 'tw-amp-loom-style';
      st.textContent = [
        '#slidecarthq .tw-pk-cache{display:none!important}',
        '#slidecarthq .tw-pk .tw-pk-mos{display:grid;gap:3px;width:100%;aspect-ratio:1/1;align-content:center;background:#fff;border-radius:8px;padding:2px;box-sizing:border-box}',
        '#slidecarthq .tw-pk .tw-pk-mos img{width:100%!important;height:auto!important;aspect-ratio:3/4;object-fit:contain;display:block;margin:0!important}',
        '#slidecarthq .tw-pk .tw-pk-offre{display:inline-block;margin:4px 0 6px;padding:3px 8px;border-radius:4px;background:#1b1b1b;color:#fff;font-size:12px;font-weight:700;letter-spacing:.3px;text-transform:uppercase}',
        '#slidecarthq .tw-pk ul.tw-pk-liste{list-style:none;margin:0;padding:0;display:grid;grid-template-columns:1fr 1fr;column-gap:10px;font-size:13px;line-height:1.5;opacity:.75}',
        '#slidecarthq .tw-pk ul.tw-pk-liste li{display:block;margin:0;padding:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}',
        '#slidecarthq .tw-pk .tw-pk-n{font-weight:700;margin-right:4px}',
        '#slidecarthq .tw-up .tw-up-opts{display:flex;flex-direction:column;gap:4px;margin-top:6px}',
        '#slidecarthq .tw-up select{width:100%;font:inherit;font-size:12px;padding:4px 6px;border:1px solid #d8d8d8;border-radius:4px;background:#fff;color:#1b1b1b;-webkit-appearance:auto;appearance:auto;height:auto;min-height:0}',
        '#slidecarthq .tw-up .upsell-add button[disabled]{opacity:.5}',
        '#slidecarthq .tw-up .tw-up-offre{display:block;width:max-content;max-width:100%;margin:4px auto 2px!important;padding:3px 7px!important;border-radius:4px;background:#1b1b1b;color:#fff;font-size:10px!important;font-weight:600;letter-spacing:.02em!important;line-height:1.3!important;white-space:nowrap}',
        '#slidecarthq .tw-gift-free{color:rgb(0,193,84)}'
      ].join('');
      document.head.appendChild(st);
    }

    function lirePanier() {
      if (lecture) return lecture;
      lecture = fetch(racine + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { panier = c; lecture = null; planifier(); })
        .catch(function () { lecture = null; });
      return lecture;
    }
    function lireProduits() {
      if (produits) return;
      produits = [];
      Promise.all(UPSELLS.map(function (h) {
        return fetch(racine + 'products/' + h + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      })).then(function (l) { produits = l.filter(function (p) { return p && p.available; }); planifier(); });
    }

    /* a) Pack groupé */
    function offre(t) {
      var p = String(t || '').split('—');
      var o = (p[1] || p[0] || '').trim().toLowerCase().replace(/(^|[\s,])([a-z])/g, function (m, a, b) { return a + b.toUpperCase(); });
      return o.replace(/\bFree\b/g, 'FREE');
    }
    function packs(t) {
      var groupes = {}, ordre = [];
      (panier.items || []).forEach(function (it) {
        var b = it.properties && it.properties._bundle;
        if (!b) return;
        var k = it.product_id + '|' + b;
        if (!groupes[k]) { groupes[k] = { titre: b, produit: it.product_title, lignes: [] }; ordre.push(k); }
        groupes[k].lignes.push(it);
      });
      var vus = {};
      ordre.forEach(function (k) {
        var g = groupes[k];
        var n = g.lignes.reduce(function (s, it) { return s + it.quantity; }, 0);
        if (n < 2) return;
        var doms = g.lignes.map(function (it) { return t.querySelector('.item[data-line-item-key="' + it.key + '"]'); });
        if (doms.some(function (d) { return !d; })) return; // AMP pas encore à jour : on attend le prochain rendu
        var id = 'p' + k.replace(/[^a-z0-9]/gi, '');
        vus[id] = true;
        var orig = 0, fin = 0, pieces = [];
        g.lignes.forEach(function (it) {
          lireBarres(it.handle);
          orig += Math.max(it.original_line_price, (barres[it.variant_id] || 0) * it.quantity); fin += it.final_line_price;
          for (var i = 0; i < it.quantity; i++) pieces.push(it);
        });
        var sig = g.lignes.map(function (it) { return it.key + ':' + it.quantity + ':' + it.final_line_price; }).join(',') + '|' + orig;
        var carte = t.querySelector('.tw-pk[data-tw-pk="' + id + '"]');
        if (!carte) {
          carte = document.createElement('div');
          carte.className = 'item tw-pk';
          carte.setAttribute('role', 'listitem');
          carte.setAttribute('data-tw-pk', id);
        }
        if (carte.getAttribute('data-sig') !== sig) {
          var cols = pieces.length >= 6 ? 3 : Math.min(pieces.length, 3);
          var mos = pieces.slice(0, 9).map(function (it) { return '<img src="' + esc(img(it.image, 160)) + '" alt="" loading="lazy">'; }).join('');
          var liste = g.lignes.map(function (it) {
            var v = (it.variant_title || '').split(' / ').join(' · ');
            return '<li>' + (it.quantity > 1 ? '<span class="tw-pk-n">' + it.quantity + '×</span>' : '') + esc(v) + '</li>';
          }).join('');
          carte.innerHTML =
            '<div class="item-container">' +
              '<div class="item-image-anchor"><div class="tw-pk-mos" style="grid-template-columns:repeat(' + cols + ',1fr)">' + mos + '</div></div>' +
              '<div class="main"><div class="main-top"><div class="main-top-left">' +
                '<span class="title">' + esc(g.produit) + ' — ' + pieces.length + '-Pack</span>' +
                '<div><span class="tw-pk-offre">' + esc(offre(g.titre)) + '</span></div>' +
                '<ul class="tw-pk-liste">' + liste + '</ul>' +
              '</div><button type="button" class="remove" data-tw-pk-retirer aria-label="Remove ' + esc(g.produit) + ' ' + pieces.length + '-Pack">' + ((doms[0].querySelector('.remove') || {}).innerHTML || CROIX) + '</button></div>' +
              '<div class="main-bottom"><p class="price-discount-block">' +
                (orig > fin ? '<span class="price strike-through line-item-discount" style="opacity:.7;text-decoration:line-through">' + argent(orig) + '</span>' : '') +
                '<span class="price">' + argent(fin) + '</span>' +
                (orig > fin ? '<span class="savings-text" style="color:rgb(0,193,84)">(Save ' + argent(orig - fin) + ')</span>' : '') +
              '</p></div></div>' +
            '</div>';
          carte.setAttribute('data-sig', sig);
          carte.setAttribute('data-keys', g.lignes.map(function (it) { return it.key; }).join(','));
        }
        if (carte.nextElementSibling !== doms[0] || carte.parentNode !== doms[0].parentNode) doms[0].parentNode.insertBefore(carte, doms[0]);
        doms.forEach(function (d) { if (!d.classList.contains('tw-pk-cache')) d.classList.add('tw-pk-cache'); });
      });
      // Pack retiré ou modifié : on enlève sa carte et on ré-affiche les lignes qui ne sont plus dans un pack.
      t.querySelectorAll('.tw-pk').forEach(function (c) { if (!vus[c.getAttribute('data-tw-pk')]) c.parentNode.removeChild(c); });
      t.querySelectorAll('.item.tw-pk-cache').forEach(function (d) {
        var k = d.getAttribute('data-line-item-key');
        var garde = false;
        t.querySelectorAll('.tw-pk').forEach(function (c) { if ((',' + c.getAttribute('data-keys') + ',').indexOf(',' + k + ',') > -1) garde = true; });
        if (!garde) d.classList.remove('tw-pk-cache');
      });
    }

    /* b) Slider d'upsell */
    function tailleDuPanier() {
      var c = {};
      ((panier && panier.items) || []).forEach(function (it) {
        (it.options_with_values || []).forEach(function (o) { if (/^size$/i.test(o.name)) c[o.value] = (c[o.value] || 0) + it.quantity; });
      });
      var best = null; Object.keys(c).forEach(function (k) { if (!best || c[k] > c[best]) best = k; });
      return best;
    }
    function variante(p, carte) {
      var vals = [].map.call(carte.querySelectorAll('select[data-o]'), function (s) { return s.value; });
      return p.variants.filter(function (v) { return v.options.every(function (o, i) { return vals[i] == null || o === vals[i]; }); })[0];
    }
    function majCarte(p, carte) {
      var v = variante(p, carte);
      var b = carte.querySelector('[data-tw-up-add]');
      // Vignette = la photo « variante » détourée de la couleur choisie (médias du produit), sinon la photo de la variante.
      var slug = v ? String(v.options[0] || '').toLowerCase().trim().replace(/\s+/g, '-') : '';
      var propre = slug && (p.images || []).filter(function (u) { u = String(u).toLowerCase(); return u.indexOf('variant') > -1 && u.indexOf('-' + slug + '-') > -1; })[0];
      var src = propre || (v && v.featured_image && v.featured_image.src) || p.featured_image;
      var im = carte.querySelector('.upsell-image img');
      var nv = img(src, 300);
      if (im && im.getAttribute('src') !== nv) im.setAttribute('src', nv);
      var pr = carte.querySelector('[data-tw-up-prix]');
      if (pr && v) {
        pr.innerHTML = '<p data-testid="AupsellPrice">' + argent(v.price) + '</p>' +
          (v.compare_at_price > v.price ? '<span class="amp-sc__visually-hidden">Original price </span><p class="upsell-compare-at">' + argent(v.compare_at_price) + '</p>' : '');
      }
      if (b) {
        var ok = !!(v && v.available);
        b.disabled = !ok;
        b.textContent = ok ? 'Add' : 'Sold out';
        b.setAttribute('aria-label', v ? 'Add ' + p.title + ', ' + v.title + ' for ' + argent(v.price) : 'Unavailable');
      }
    }
    function carteUpsell(p) {
      var carte = document.createElement('div');
      carte.className = 'upsell multi tw-up';
      carte.setAttribute('data-tw-up', p.handle);
      var taille = tailleDuPanier();
      var opts = p.options.map(function (o, i) {
        var nom = o.name || ('Option ' + (i + 1));
        var vals = o.values || [];
        var choix = /^size$/i.test(nom) && taille && vals.indexOf(taille) > -1 ? taille : null;
        if (!choix) { var dispo = p.variants.filter(function (v) { return v.available; })[0]; choix = dispo ? dispo.options[i] : vals[0]; }
        if (vals.length < 2) return '<select data-o="' + i + '" hidden><option>' + esc(vals[0]) + '</option></select>';
        return '<select data-o="' + i + '" aria-label="' + esc(nom) + '">' + vals.map(function (v) {
          return '<option value="' + esc(v) + '"' + (v === choix ? ' selected' : '') + '>' + esc(v) + '</option>';
        }).join('') + '</select>';
      }).join('');
      var url = racine + 'products/' + p.handle;
      carte.innerHTML =
        '<div class="upsell-item">' +
          '<div class="upsell-image"><a href="' + esc(url) + '" aria-hidden="true" tabindex="-1"><img alt="' + esc(p.title) + '" class="small" src=""></a></div>' +
          '<div class="upsell-text"><p><a href="' + esc(url) + '" data-testid="AupsellTitle">' + esc(p.title) + '</a></p>' +
            '<div class="upsell-text-prices" data-tw-up-prix></div>' +
            '<div class="tw-up-offre">BUY 3, GET 3 FREE</div>' +
            '<div class="tw-up-opts">' + opts + '</div></div>' +
          '<div class="upsell-add"><button type="button" data-tw-up-add>Add</button></div>' +
        '</div>';
      carte.addEventListener('change', function () { carte.setAttribute('data-touche', '1'); majCarte(p, carte); });
      carte.querySelector('[data-tw-up-add]').addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var v = variante(p, carte), b = this;
        if (!v || !v.available) return;
        b.disabled = true; b.textContent = 'Adding...';
        fetch(racine + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
        }).then(function (r) { if (!r.ok) throw new Error('add'); })
          .then(function () { try { return window.SLIDECART_UPDATE(); } catch (e) {} })
          .catch(function (x) { if (window.console) console.warn('[tw-amp-cart] upsell', x); })
          .then(function () { majCarte(p, carte); });
      });
      majCarte(p, carte);
      return carte;
    }
    function upsells(t) {
      if (!produits || !produits.length) return;
      var slider = t.querySelector('.upsells .upsells-slider');
      if (!slider) return;
      var ids = (panier.items || []).map(function (it) { return it.product_id; });
      var premier = slider.firstElementChild;
      produits.forEach(function (p, i) {
        var carte = slider.querySelector('.tw-up[data-tw-up="' + p.handle + '"]');
        if (!carte) carte = carteUpsell(p);
        var cible = i === 0 ? slider.firstElementChild : slider.querySelector('.tw-up[data-tw-up="' + produits[i - 1].handle + '"]').nextElementSibling;
        if (carte !== cible) slider.insertBefore(carte, cible);
        // Taille proposée = celle des articles du panier (tant que la cliente n'a pas choisi elle-même).
        var tl = tailleDuPanier(), st = carte.querySelector('select[aria-label="Size"]');
        if (!carte.hasAttribute('data-touche') && tl && st && st.value !== tl && [].some.call(st.options, function (o) { return o.value === tl; })) { st.value = tl; majCarte(p, carte); }
        carte.style.display = ids.indexOf(p.id) > -1 ? 'none' : ''; // déjà au panier → on ne le repropose pas (comme AMP)
      });
    }

    /* c) + d) Textes et cadeau */
    function textes(hote) {
      var w = document.createTreeWalker(hote, NodeFilter.SHOW_TEXT), n;
      while ((n = w.nextNode())) {
        if (n.nodeValue.indexOf('Ship By Tomorrow') > -1) n.nodeValue = n.nodeValue.replace('Ship By Tomorrow', 'Ships Today');
      }
    }
    function cadeau(t) {
      if (DEVISE !== 'USD') return;
      CADEAUX.forEach(function (id) {
        t.querySelectorAll('.item[data-variant-id="' + id + '"] .price-discount-block').forEach(function (bloc) {
          if (bloc.querySelector('.tw-gift-barre')) return;
          var barre = document.createElement('span');
          barre.className = 'price strike-through line-item-discount tw-gift-barre';
          barre.style.cssText = 'opacity:.7;text-decoration:line-through';
          barre.textContent = argent(CADEAU_VALEUR);
          bloc.insertBefore(barre, bloc.firstChild);
          var libre = document.createElement('span');
          libre.className = 'savings-text tw-gift-free';
          libre.textContent = '(FREE)';
          bloc.appendChild(libre);
        });
      });
    }

    function decorer() {
      var hote = document.getElementById('slidecarthq');
      if (!hote) return;
      style();
      textes(hote);
      var t = tiroir();
      if (!t) return;
      cadeau(t);
      if (!panier) { lirePanier(); return; }
      packs(t);
      upsells(t);
      remise(t);
    }
    // Ligne « Discounts » de l'app = même économie que le « (Save …) » du sous-total (Samuel 12/10 : un seul chiffre partout).
    function remise(t) {
      var a = t.querySelector('.slidecart-discount-amount');
      if (!a) return;
      var s = Array.prototype.find.call(t.querySelectorAll('footer *'), function (x) {
        return x.childElementCount === 0 && /^\((Save|Économisez) .+\)$/.test((x.textContent || '').trim());
      });
      if (!s) return;
      var m = s.textContent.trim().match(/^\((?:Save|Économisez) (.+)\)$/);
      var v = '-' + m[1];
      if (a.textContent.trim() !== v) a.textContent = v;
    }
    function planifier() {
      if (attente) return;
      attente = requestAnimationFrame(function () { attente = null; try { decorer(); } catch (e) { if (window.console) console.warn('[tw-amp-cart] loom', e); } });
    }

    // Croix de la carte pack : retire toutes les lignes du pack d'un coup (le cadeau suit via tw-gift.js).
    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest && e.target.closest('[data-tw-pk-retirer]');
      if (!b) return;
      e.preventDefault(); e.stopPropagation();
      var c = b.closest('.tw-pk'), maj = {};
      (c.getAttribute('data-keys') || '').split(',').forEach(function (k) { if (k) maj[k] = 0; });
      b.disabled = true;
      fetch(racine + 'cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: maj })
      }).then(function () { try { return window.SLIDECART_UPDATE(); } catch (x) {} })
        .catch(function (x) { if (window.console) console.warn('[tw-amp-cart] pack', x); });
    }, true);

    chainer('SLIDECART_LOADED', function () { lireProduits(); lirePanier(); });
    chainer('SLIDECART_OPENED', function () { lireProduits(); lirePanier(); });
    chainer('SLIDECART_UPDATED', function () { lirePanier(); });
    (function observerLoom() {
      var hote = document.getElementById('slidecarthq');
      if (!hote) { setTimeout(observerLoom, 500); return; }
      lireProduits(); lirePanier();
      new MutationObserver(planifier).observe(hote, { childList: true, subtree: true, characterData: true });
    })();
  })();

  ouvrirSiDemande();
  window.addEventListener('hashchange', ouvrirSiDemande);
  observer();
})();
